__webpack_public_path__ = window.__webpack_public_path__;

import "default";
